const ClientMemberList = `query getClientMember($clientId: Int!){
  getClientMember(clientId: $clientId){
    clientMemberId
    applicantId{
      viaForm
      userId{
        id
        username
        firstName
        lastName
        email
        city
        country
        isActive
        linkedinUrl
      }
    }
  }
}`;

const ClientMemberDetail = `query getClientMemberByClientMemberId($clientMemberId: Int!){
  getClientMemberByClientMemberId(clientMemberId: $clientMemberId){
    clientMemberId    
    applicantId{
      userId{
        id
        username
        firstName
        lastName
        email
        city
        state
        country
        isActive
        phoneNo
        linkedinUrl
      }
      originalEmail
      originalEmailUpdateBy
      originalEmailUpdateDate
    }
  }
}`;

const ClientMemberListByTermAndTeam = `
  query ( $clientId: Int!
          $teamTermId: Int!
          $termId: Int!)
  {
  getClientMemberByTermAndTeam(clientId: $clientId,teamTermId: $teamTermId, termId: $termId)
  {
    clientMember
    {
      clientMemberId
      applicantId
      {
        userId
        {
          id
          firstName
          lastName
        }
      }
      noOfTerms
    }
    selected
    roleName
    disabled
    teamTermMembers
    {
      completed
      roleId
      {
        roleName
      }
      teamTermId
      {
        teamTermId
        teamId
        {
          name
        }
        termId{
          termId
          termUuid
          name
        }
      }
    }
  }
}`;

const EditClientMember_mutate = `
  mutation EditMember(
    $clientMemberId: Int!,
    $username: String!,    
    $firstName: String!,
    $lastName: String!,
    $email: String!,
    $phoneNo: String,
    $city: String,
    $state: String,
    $country: String,
    $linkedinUrl: String) {
    editMember(
      clientMemberId: $clientMemberId,
      username: $username,  
      firstName: $firstName,
      lastName: $lastName,
      email: $email,      
      phoneNo: $phoneNo,
      city: $city,
      state: $state,
      country: $country,
      linkedinUrl: $linkedinUrl) 
      {
        user{
          username  
          firstName
          lastName
          email      
          phoneNo
          city
          state
          country
          linkedinUrl
        }
      }
    }
`;

module.exports = {
  CLIENT_MEMBER_LIST: ClientMemberList,
  CLIENT_MEMBER_DETAIL: ClientMemberDetail,
  EDIT_CLIENT_MEMBER_MUTATION: EditClientMember_mutate,
  CLIENT_MEMBER_LIST_BY_TERM_TEAM: ClientMemberListByTermAndTeam,
};
